import { useMemo } from 'react';
import { useRenderers } from '../../../../renderProps';
import {
	renderFareOptionsTypeIcon as defaultRenderFareOptionsTypeIcon,
	renderFeaturePaymentTypeIcon as defaultRenderFeaturePaymentTypeIcon
} from '../lib/utils';

export const useFareOverrides = () => {
	const {
		renderFeaturePaymentTypeIcon = defaultRenderFeaturePaymentTypeIcon,
		renderFareOptionsTypeIcon = defaultRenderFareOptionsTypeIcon
	} = useRenderers();

	return useMemo(() => ({ renderFeaturePaymentTypeIcon, renderFareOptionsTypeIcon }), [
		renderFeaturePaymentTypeIcon,
		renderFareOptionsTypeIcon
	]);
};
